import { useQuery } from "@tanstack/react-query";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { apiStats } from "../api.js";
import { Card, PageHeader, fmtNum } from "../components/ui.js";

export function DashboardPage() {
  const overview = useQuery({ queryKey: ["stats", "overview"], queryFn: () => apiStats.overview() });
  const keywords = useQuery({ queryKey: ["stats", "keywords"], queryFn: () => apiStats.keywords() });

  return (
    <>
      <PageHeader title="Dashboard" />
      <div className="grid grid-cols-5 gap-4 mb-6">
        <Stat label="Projects" value={overview.data?.project_count} />
        <Stat label="Enabled projects" value={overview.data?.enabled_project_count} />
        <Stat label="KOCs" value={overview.data?.koc_count} />
        <Stat label="Videos tracked" value={overview.data?.video_count} />
        <Stat label="New videos last 7d" value={overview.data?.videos_last_7d} />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card>
          <h2 className="text-sm font-semibold text-stone-700 mb-3">Keyword hits / day (last 30d)</h2>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={overview.data?.hits_last_30d ?? []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="count" fill="#10b981" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <Card>
          <h2 className="text-sm font-semibold text-stone-700 mb-3">Top keywords by hit count</h2>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={(keywords.data?.keywords ?? []).slice(0, 12)}
                layout="vertical"
                margin={{ left: 60, right: 20, top: 10, bottom: 10 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" allowDecimals={false} />
                <YAxis type="category" dataKey="keyword" tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="hit_count" fill="#0ea5e9" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </>
  );
}

function Stat({ label, value }: { label: string; value: number | undefined }) {
  return (
    <Card>
      <div className="text-xs text-stone-500 mb-1">{label}</div>
      <div className="text-2xl font-semibold tabular-nums text-stone-900">
        {value === undefined ? "—" : fmtNum(value)}
      </div>
    </Card>
  );
}
